import { useEffect, useState } from 'react';

interface Props {
  value: string;
  onCommit: (next: string) => void;
  className?: string;
  type?: string;
  min?: number;
  placeholder?: string;
  multiline?: boolean;
  rows?: number;
  disabled?: boolean;
}

/** Text input that only saves when its value actually changed (on blur or
 *  Enter; Escape restores). Shared by the rate card and the deal sheet. */
export const CommitInput = ({
  value, onCommit, className = 'input', type = 'text', min, placeholder, multiline, rows = 3, disabled,
}: Props) => {
  const [draft, setDraft] = useState(value);
  useEffect(() => setDraft(value), [value]);
  const commit = () => {
    if (draft !== value) onCommit(draft);
  };
  if (multiline) {
    return (
      <textarea
        className={className}
        rows={rows}
        value={draft}
        placeholder={placeholder}
        disabled={disabled}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => { if (e.key === 'Escape') setDraft(value); }}
      />
    );
  }
  return (
    <input
      className={className}
      type={type}
      min={min}
      value={draft}
      placeholder={placeholder}
      disabled={disabled}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') (e.target as HTMLInputElement).blur();
        if (e.key === 'Escape') setDraft(value);
      }}
    />
  );
};

export default CommitInput;
